import * as React from 'react';

import { CategoryFields } from '__generated__/CategoryFields';
import { handlePromise } from 'common/utils/Bugsnag';
import { Currency, toUnit } from 'common/utils/currency';
import BudgetSlider from 'projects/components/BudgetSlider';
import CreateContext from 'projects/components/CreateContext';
import { ObservableField as Field, ObservableForm } from 'projects/components/ObservableForm';
import { FormattedNumber } from 'react-intl';

interface Fields {
    budget: number;
}

export interface Props<T> {
    form: ObservableForm<T>;
    currency: Currency;
    category: CategoryFields | null;
}

export function BudgetSummary(props: { budget: number; currency: Currency | null }) {
    const { budget } = props;
    let { currency } = props;
    const { site } = React.useContext(CreateContext);

    if (!currency) {
        currency = site!.currency as Currency;
    }

    return budget === 0 ? (
        <>{__('Any price')}</>
    ) : (
        <FormattedNumber
            value={toUnit(budget, currency)}
            style="currency"
            currency={currency}
            minimumFractionDigits={0}
        />
    );
}

export default function BudgetField<T extends Fields>({ form, currency, category }: Props<T>) {
    const onSliderChange = (budget: number) => {
        handlePromise(Promise.all([form.set('budget', budget)]), 'TimeAndBudgetPage');
    };

    return (
        <Field
            form={form}
            name={['budget']}
            title={__("What's your budget?")}
            message={__('Your designer will use your budget and brief details to provide a quote')}
            render={() => (
                <>
                    <BudgetSlider
                        budget={form.get('budget')}
                        onSliderChange={onSliderChange}
                        currency={currency}
                        category={category}
                    />
                    <p>
                        {__(
                            '*99designs adds a 5% platform fee to cover support and processing payment'
                        )}
                    </p>
                </>
            )}
        />
    );
}
